import { render, staticRenderFns } from "./TestingCenterDayPage.vue?vue&type=template&id=da1226e4&"
import script from "./TestingCenterDayPage.vue?vue&type=script&lang=ts&"
export * from "./TestingCenterDayPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports